module.exports = __webpack_public_path__ + "static/media/screwHandle.2bb2a811.png";